export type {
    GenerationLock,
    GenerationRecord,
    DismissalRecord,
    StoredPatch,
    CustomizationsConfig,
    MoveDeclaration,
    ReplayResult,
    FileResult,
    ConflictRegion,
    ConflictReason,
    ConflictMetadata,
    MergeResult,
    CommitInfo,
    ReplayConfig,
    FlowKind,
    DegradedReason,
    DegradedReasonCode,
} from "./types.js";

export {
    CREDENTIAL_PATTERNS,
    SENSITIVE_FILE_PATTERNS,
    isSensitiveFile,
    scanForCredentials,
    type CredentialPattern,
} from "./credentials.js";

export { GitClient } from "./git/GitClient.js";
export {
    isGenerationCommit,
    isReplayCommit,
    isRevertCommit,
    parseRevertedSha,
    parseRevertedMessage,
    FERN_BOT_NAME,
    FERN_BOT_EMAIL,
    FERN_BOT_LOGIN,
} from "./git/CommitDetection.js";
export { LockfileManager, LockfileNotFoundError } from "./LockfileManager.js";
export { ReplayDetector, type DetectionResult, type MaterializedCommitPatch } from "./ReplayDetector.js";
export { threeWayMerge } from "./ThreeWayMerge.js";
export { ReplayApplicator } from "./ReplayApplicator.js";
export { ReplayCommitter, type CommitOptions } from "./ReplayCommitter.js";
export {
    ReplayService,
    type ReplayReport,
    type ReplayOptions,
    type ApplyOptions,
    type ReplayPreparation,
    type ConflictDetail,
    type UnresolvedPatchInfo,
} from "./ReplayService.js";
export { FernignoreMigrator, type MigrationAnalysis, type MigrationResult } from "./FernignoreMigrator.js";
export {
    bootstrap, type BootstrapOptions, type BootstrapResult,
    forget, type ForgetOptions, type ForgetResult, type MatchedPatch, type DiffStat,
    reset, type ResetOptions, type ResetResult,
    resolve, type ResolveOptions, type ResolveResult,
    status, type StatusResult, type StatusPatch, type StatusGeneration, type StatusDismissal,
} from "./commands/index.js";
